import React from "react";
import MoreButton from "../Custom/MoreButton";
import styles from "./Filter.module.css";
import CustomizedSelect from "../../Atoms/Inputs/CustomizedSelect";
import Buttons from "../../Atoms/Buttons/Buttons";
import filter from "../../../assets/Imagess/filter.svg";
import emailICon from "../../../assets/Imagess/emaildropdownicon.svg";

const EmailFilter = () => {
  return (
    <MoreButton icon={filter} width='400px'>
      <div className={styles["filter-container"]}>
        <h4> Filter</h4>
        <CustomizedSelect
          //   options={selectedField}
          label='Email Type'
          icon={emailICon}
          placeholder='Select Type'
          //   value={params.field}
          //   onChange={(selectedValue) =>
          //     setParams((prevParams) => ({
          //       ...prevParams,
          //       field: selectedValue.value,
          //     }))
          //   }
        />
        <div className={styles["filterbutton-container"]}>
          <Buttons
            text='Reset Filter'
            //    handleOnClick={handleReset}
          />
          <Buttons
            text='Show Result'
            type='Submit'
            // handleOnClick={handleShowResult}
          />
        </div>
      </div>
    </MoreButton>
  );
};

export default EmailFilter;
